/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Condition } from './condition';
import { InsurancePeriod } from './insurancePeriod';
import { InsuredVehicleRef } from './insuredVehicleRef';
import { MotorVehicleProduct } from './motorVehicleProduct';
import { PaymentContributor } from './paymentContributor';
import { Price } from './price';
import { PrivateLiabilityInsurance } from './privateLiabilityInsurance';
import { PaymentFrequency } from './paymentFrequency';
import { PrivateLiabilityPackage } from './privateLiabilityPackage';
import { PrivateLiabilityProduct } from './privateLiabilityProduct';
import { PaymentMethod } from './paymentMethod';
import { PrivateLiabilityTariff } from './privateLiabilityTariff';

/**
 * @type Product
 * @export
 */
export type Product = MotorVehicleProduct | PrivateLiabilityProduct;
